// Event Guests Service
// One check-in per anonymous attendee per event (ITER-099). The server counts them in onEventGuestJoined.

import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';

function guestStorageKey(eventId: string): string {
  return `votebeats_guest_${eventId}`;
}

function hasStoredCheckIn(eventId: string): boolean {
  try {
    return localStorage.getItem(guestStorageKey(eventId)) !== null;
  } catch (error) {
    console.warn('Guest check-in: localStorage is unavailable, checking Firestore instead', error);
    return false;
  }
}

function storeCheckIn(eventId: string): void {
  try {
    localStorage.setItem(guestStorageKey(eventId), '1');
  } catch (error) {
    console.warn('Guest check-in: could not remember the check-in in localStorage', error);
  }
}

export async function recordEventGuest(eventId: string, attendeeId: string): Promise<'recorded' | 'already'> {
  if (hasStoredCheckIn(eventId)) return 'already';

  const guestRef = doc(db, 'events', eventId, 'guests', attendeeId);
  const existing = await getDoc(guestRef);
  if (existing.exists()) {
    storeCheckIn(eventId);
    return 'already';
  }

  await setDoc(guestRef, { joinedAt: serverTimestamp() });
  storeCheckIn(eventId);
  return 'recorded';
}

export async function hasTakenPart(eventId: string, attendeeId: string): Promise<boolean> {
  if (hasStoredCheckIn(eventId)) return true;
  const existing = await getDoc(doc(db, 'events', eventId, 'guests', attendeeId));
  if (!existing.exists()) return false;
  storeCheckIn(eventId);
  return true;
}
